module.exports = __webpack_public_path__ + "img/chevron-left.68056ced.svg";